'use strict';

var _ = require('lodash');
var ApplicationConstants = require('../constants/ApplicationConstants');
var SelectCustomerConstants = require('../constants/SelectCustomerConstants.js');
var Formatter = require('./Formatter');
var AccountTypes = ApplicationConstants.AccountTypeCodes;
var YdConstants = require('../constants/YourDetailsConstants');
var AssetAllocationsAPI = require('../apis/AssetAllocationsAPI.js');
var Products = require('./Products.js');
var InvestmentAllocationHelper = require('./InvestmentAllocationHelper.js');

function setApplicationProcessMode(applicationData, processMode) {
    if (applicationData) {
        applicationData.isApplicationDataNotReadyForFunding = processMode === ApplicationConstants.ApplicationProcessModes.OFFLINE ?
            true : (processMode === ApplicationConstants.ApplicationProcessModes.ONLINE ? false : undefined)
    }
}

function getClientFieldValue(applicationData, fieldName, defaultValue) {
    let value = defaultValue;
    if (!applicationData || !applicationData.form || !applicationData.form.yourDetails) {
        return value;
    }

    const yd = applicationData.form.yourDetails;
    if (applicationData.form.accountType === ApplicationConstants.AccountTypeCodes.JOINT) {
        if (yd.investorList && yd.investorList.length >= 1) {
            // first joint member is the main applicant
            value = yd.investorList[0][fieldName]
        }
    }
    else {
        value = yd[fieldName];
    }

    return value;
}

function getInvestorListName(investorList) {
    if (investorList) {
        let names = [];
        _.forEach(investorList, function (value) {
            if (value.trusteeType && value.trusteeType === YdConstants.TrusteeType.CORPORATE) {
                names.push(value.corporateTrustee);
            } else {
                names.push(Formatter.formatFullname(undefined, value.givenName, value.lastName));
            }
        });
        return names;
    }
}

module.exports = {
    isBusinessAccountType: function (accountType) {
        var businessAccountTypes = [ApplicationConstants.AccountTypeCodes.COMPANY, ApplicationConstants.AccountTypeCodes.TRUST, ApplicationConstants.AccountTypeCodes.SMSF, ApplicationConstants.AccountTypeCodes.PARTNERSHIP];
        return businessAccountTypes.indexOf(accountType) !== -1;
    },

    getClientOin: function (applicationData) {
        return getClientFieldValue(applicationData, 'oin', 0);
    },

    getClientCif: function (applicationData) {
        return getClientFieldValue(applicationData, 'cif', 0);
    },

    getClientKycFlag: function (applicationData) {
        return getClientFieldValue(applicationData, 'kycFlag', false);
    },
    
    getClientFieldValue: getClientFieldValue,

    findApplicationLinkType: function (applicationLinkType) {
        return _.find(SelectCustomerConstants.ClientTypeOptions, { id: applicationLinkType });
    },

    setApplicationProcessMode: setApplicationProcessMode,

    getInvestorNames(applicationData) {
        if (!applicationData || !applicationData.form) {
            return [];
        }
        let yd = applicationData.form.yourDetails, accountType = applicationData.form.accountType, names = [];

        if (yd && accountType) {
            if (accountType !== AccountTypes.JOINT) {
                switch (accountType) {
                    case AccountTypes.SMSF:
                    case AccountTypes.TRUST:
                    case AccountTypes.COMPANY:
                    case AccountTypes.PARTNERSHIP:
                        names.push(yd.businessName);
                        break;
                    default:
                        names.push(Formatter.formatFullname(undefined, yd.givenName, yd.lastName));
                        break;
                }
            }

            if (yd.investorList && yd.investorList.length > 0) {
                names = names.concat(getInvestorListName(yd.investorList));
            }
            else if (yd.trusteeList && yd.trusteeList.length > 0) {
                names = names.concat(getInvestorListName(yd.trusteeList));
            }
        }
        return names;
    },

    isCfpAdvised(applicationData) {
        return applicationData &&   
            applicationData.originationSource === ApplicationConstants.OriginationSources.IRESS &&
            applicationData.originationType === ApplicationConstants.OriginationTypes.INTEGRATED &&
            window.NOA.userContext.dealerCode === ApplicationConstants.CfpAdviserDealerCode;
    },
    
    postApplicationRetrieval(application) {
            // TODO: move all application post retrieval activities here
        if (!Products.isAnnuity(application.productId)) {
            var investmentOptions = InvestmentAllocationHelper.getInvestmentOptions(application);
            if (investmentOptions && investmentOptions.length > 0) {
                var investmentOptionIds = _.pluck(investmentOptions, 'id');
                var inSpecieSetup = _.get(application, 'form.inSpecieTransfer.setUp', null) === ApplicationConstants.YesNoValues.YES;
                if (investmentOptionIds && investmentOptionIds.length > 0) {
                    AssetAllocationsAPI.getAssetAllocationsList(application.productId, investmentOptionIds, inSpecieSetup);
                }
            }
        }
    },

    getApplicationWithoutPredictiveSearchAdviceFee(application) {
        let result = _.cloneDeep(application);
        if (_.get(result, 'form.inSpecieTransfer.setUp', null) === ApplicationConstants.YesNoValues.YES) {
            // if any internal manual 
            const fundingSources = _.get(result, 'form.fundingYourProduct.fundingSources', []);
            if (_.some(fundingSources, { isExistingAccount: false })) {
                _.set(result, 'form.adviceFee.adviceFeeOption', ApplicationConstants.YesNoValues.NO);
                _.set(result, 'form.adviceFee.AdviceFeesList', []);
                _.set(result, 'form.adviceFee.IsFeesExcessive', false);
            }
        }

        return result;
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/ApplicationHelper.js